// extracted by mini-css-extract-plugin
export var avatarButton = "header-module--avatarButton--t5U-c";
export var logo = "header-module--logo--y97xu";
export var profile = "header-module--profile--YH0GX";
export var profileAvatar = "header-module--profileAvatar--IA51N";
export var profileIcon = "header-module--profileIcon--bOEmD";
export var profileName = "header-module--profileName--ykQ1C";
export var profileNav = "header-module--profileNav--RdYgn";
export var profileToggle = "header-module--profileToggle--Veyon";
export var root = "header-module--root--t41PD";